/**
 * Versão atual dos termos legais.
 * Incrementar quando termos/privacidade mudam materialmente — médicos
 * precisam aceitar de novo. A chave localStorage inclui essa versão.
 *
 * Historial de versões:
 *   v1 (2026-05-06) — Versão inicial com 5 pontos essenciais LGPD/GDPR.
 */
export const LEGAL_VERSION = 1;

/**
 * Chave localStorage versionada para persistência do consent.
 * Ex.: "drpera-legal-accepted-v1"
 */
export const LEGAL_STORAGE_KEY = `drpera-legal-accepted-v${LEGAL_VERSION}`;
